import { Controller } from '@hotwired/stimulus';
import { Helpers } from '../helpers';
import * as bootstrap from 'bootstrap';

export default class InvestFormController extends Controller {
  static targets = [
    'subscriptionAmount',
    'feesAmount',
    'numberOfSharesError',
    'fieldsErrors',
    'subscriptionAmountDivs',
    'feesAmountDivs',
    'totalAmountDivs',
    'numberOfSharesDivs',
    'nonInformedFields',
    'modalTotalWithFees',
    'submitButton',
    'insufficientBalance',
    'subscribeModal',
  ];

  static values = {
    feesUrl: String,
    projectId: Number,
    profileBalance: Number,
    maxInvestRecommendation: Number,
    userMayHaveWarning: Boolean,
    shareNumber: Number,
  };

  // Compute fees and total through backend
  computeFeesAndTotal() {
    const amount = this.subscriptionAmountTarget.value;
    let controller = this;

    Rails.ajax({
      type: 'GET',
      url: this.feesUrlValue,
      data: 'amount=' + amount + '&project_id=' + this.projectIdValue,
      dataType: 'json',
      success: function (response) {
        const feesAmount = parseFloat(response['fees_amount']);
        const totalWithFeesAmount = parseFloat(response['total_with_fees']);
        const numberOfShares = parseFloat(response['number_of_shares'])

        // Check if the amount is valid
        controller.checkAmountValidity(amount, totalWithFeesAmount);

        // Display fees and total
        controller.feesAmountTarget.value = feesAmount;
        controller.subscriptionAmountDivsTargets.innerHTML =
          controller.updateAmounts(
            controller.subscriptionAmountDivsTargets,
            parseFloat(amount)
          );
        controller.feesAmountDivsTargets.innerHTML = controller.updateAmounts(
          controller.feesAmountDivsTargets,
          feesAmount
        );
        controller.totalAmountDivsTargets.innerHTML = controller.updateAmounts(
          controller.totalAmountDivsTargets,
          totalWithFeesAmount
        );
        controller.numberOfSharesDivsTargets.innerHTML = controller.updateAmounts(
          controller.numberOfSharesDivsTargets,
          numberOfShares,
          'actions'
        );
        controller.modalTotalWithFeesTarget.innerHTML =
          Helpers.numberToCurrency(totalWithFeesAmount, 2);
      },
      error: function () {
        controller.fieldsErrorsTarget.innerHTML =
          'Une erreur s\'est produite, veuillez réessayer.';
      },
    });
  }

  checkAmountValidity(amount, totalWithFeesAmount) {
    this.insufficientBalanceTarget.classList.add('d-none');

    const profileBalance = parseFloat(this.profileBalanceValue);
    const shareNumber = parseFloat(this.shareNumberValue);
    const parsedAmount = parseFloat(amount);
    const minAmount = parseFloat(this.subscriptionAmountTarget.min || 0);

    switch (true) {
      case amount === '':
        this.fieldsErrorsTarget.innerHTML =
          'Veuillez renseigner un montant d\'investissement.';
        this.triggerError();
      case parsedAmount < minAmount:
        this.fieldsErrorsTarget.innerHTML =
          `Le ticket minimum d’investissement est de ${Helpers.numberToCurrency(minAmount, 0)}.`;
        this.triggerError();
      case !this.subscriptionAmountTarget.checkValidity():
        this.fieldsErrorsTarget.innerHTML =
          this.subscriptionAmountTarget.validationMessage;
        this.triggerError();
      case parsedAmount % shareNumber !== 0:
        this.numberOfSharesErrorTarget.classList.remove('form-text');
        this.numberOfSharesErrorTarget.classList.add('form-error');
        return this.triggerError();
      case totalWithFeesAmount > profileBalance:
        this.insufficientBalanceTarget.classList.remove('d-none');
        this.fieldsErrorsTarget.innerHTML = '';
        return this.triggerError();
      default:
        this.numberOfSharesErrorTarget.classList.add('form-text');
        this.numberOfSharesErrorTarget.classList.remove('form-error');
        this.fieldsErrorsTarget.innerHTML = '';
        this.subscriptionAmountTarget.classList.remove('is-invalid');
        return true;
    }
  }

  updateAmounts(container, amount, unit = '€') {
    let finalAmount;

    if (amount === 0 || isNaN(amount)) {
      finalAmount = `-,-- ${unit}`;
    } else if (unit === 'actions') {
      finalAmount = `${Math.floor(amount)} ${unit}`;
    } else {
      finalAmount = Helpers.numberToCurrency(amount, 2);
    }

    container.forEach((element) => {
      element.innerHTML = finalAmount;
    });
  }

  triggerError() {
    this.subscriptionAmountTarget.classList.add('is-invalid');
    return false;
  }

  validateAndShowSubscriptionModal() {
    const amount = this.subscriptionAmountTarget.value;
    const maxInvestRecommendation = this.maxInvestRecommendationValue;
    const totalWithFeesAmount =
      parseFloat(amount) + parseFloat(this.feesAmountTarget.value);

    if (!this.checkAmountValidity(amount, totalWithFeesAmount)) return;

    if (
      this.userMayHaveWarningValue === true &&
      amount > maxInvestRecommendation
    ) {
      this.nonInformedFieldsTargets.forEach((element) =>
        element.classList.remove('d-none')
      );
    } else {
      this.nonInformedFieldsTargets.forEach((element) =>
        element.classList.add('d-none')
      );
    }

    this.showModal(this.subscribeModalTarget);
  }

  preventAutoSubmit(event) {
    event.preventDefault();
    this.validateAndShowSubscriptionModal();
  }

  showModal(modalTarget) {
    const modal = new bootstrap.Modal(modalTarget);
    modal.show();
  }
}
